import React from 'react';
import styled from '@emotion/styled';
import { PoiMap } from './PoiMap';
import {
	getOverlapWithHeaderStyles,
	Header,
	SolidContentWrap,
} from '../../../shared/components';
import { PASSENGERS_SHOP_DINE_AND_RELAX_PAGE_ID } from '../../../shared/api/contentful/constants';
import { getUrlForPageId } from '../../../app/pages/ui/utils/getUrlForPageId';
import { IPageEntry } from '../../../shared/api/contentful/types';
import { useSiteMap } from '../../../app/pages/ui/utils/withSiteMap';

interface IPoiDetailProps {
	page: IPageEntry;
}

export const PoiDetail = ({ page }: IPoiDetailProps) => {
	const siteMap = useSiteMap();

	return (
		<StyledPoiDetail>
			<Header
				parentTitle={page.fields.parentTitle}
				parentUrl={getUrlForPageId(
					PASSENGERS_SHOP_DINE_AND_RELAX_PAGE_ID,
					siteMap,
				)}
				title=""
				theme={page.fields.headerTheme}
			/>
			<SolidContentWrap>
				<PoiMap />
			</SolidContentWrap>
		</StyledPoiDetail>
	);
};

const StyledPoiDetail = styled.div`
	${SolidContentWrap} {
		${getOverlapWithHeaderStyles()}
	}
`;
